import { VersionBannerComponent } from './version-banner.component'
import { OfflineBannerComponent } from './offline-banner.component'

// The one fixed bottom container — both banners are plain block-level
// content, so if they're ever both visible at once they stack instead of
// overlapping.
export const BannerStackComponent = () => (
  <div className="fixed inset-x-0 bottom-0 z-50 flex flex-col">
    <VersionBannerComponent />
    <OfflineBannerComponent />
  </div>
)
